import React from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGear } from '@fortawesome/free-solid-svg-icons';
import { faUpRightAndDownLeftFromCenter, faDownLeftAndUpRightToCenter } from '@fortawesome/free-solid-svg-icons';
import { faVolumeHigh, faVolumeXmark } from '@fortawesome/free-solid-svg-icons';
import { Slider } from '@mui/material';
import { setBooleanState, setVolume, setPreviousVolume, setSettingsView } from '../../../features/videoPlayer/videoPlayer.slice';
import PlayerSettings from './PlayerSettings';
import PlaybackSpeedSettings from './PlaybackSpeed';
import { toggleFullscreen } from '../utils/videoPlayerUtils';
// import { useHandleVolumeHover } from '../../hooks/useHandleVolumeHover';

const TopPlayerButtons = ({videoRef, containerRef, isMobile, isTablet}) => {

    const hovering = useSelector((state) => state.videoPlayer.hovering);
    const isBuffering = useSelector((state) => state.videoPlayer.isBuffering);
    const showSettings = useSelector((state) => state.videoPlayer.showSettings);
    const settingsView = useSelector((state) => state.videoPlayer.settingsView);
    const isFullscreen = useSelector((state) => state.videoPlayer.isFullscreen);
    const volume = useSelector((state) => state.videoPlayer.volume);
    const previousVolume = useSelector((state) => state.videoPlayer.previousVolume);
    const volumeHover = useSelector((state) => state.videoPlayer.volumeHover);
    const videoMetaData = useSelector((state) => state.videoPlayer.currentVideoMetaData);
    const videoTitle = useSelector((state) => state.videoPlayer.videoTitle);

    const dispatch = useDispatch();

    const handleSettingIconClick = (e) => {
          e.stopPropagation(); // Prevent the click from propagating to document
          if (showSettings) {
            dispatch(setSettingsView('main'));
          }
          dispatch(setBooleanState({ key: 'showSettings', value: !showSettings })); 
    };

    const handleVolumeHover = (isMobile, isTablet) => {
      
      if (isMobile || isTablet) return; // Skip for mobile and tablet devices
      
      dispatch(setBooleanState({ key: 'volumeHover', value: true }));
    };

    return (
        <div>
            {hovering && !isBuffering && (
                <div
                    style={{
                        position: 'absolute',
                        top: '15px',
                        left: '30px',
                        right: '30px',
                        // width: '100%',
                        // height: '100%',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        color: '#fff',
                        zIndex: 2,
                    }}
                >
                    <h4 className='title-truncate' style={{ color: '#fff' }}>{videoTitle}</h4>
                    <div className='d-flex justify-content-end flex-row'>
                        <div 
                        className='d-flex align-items-center justify-content-start gap-3' 
                        style={{ 
                            padding: '0 7px 0 20px', 
                            borderRadius: '30px',
                            backgroundColor: volumeHover ? '#1A1A1A' : 'transparent',
                            transition: 'background-color 0.5s ease',
                        }} 
                        onMouseEnter={() => handleVolumeHover(isMobile, isTablet)}
                        onMouseLeave={() => dispatch(setBooleanState({ key: 'volumeHover', value: false }))}
                        >
                        <Slider 
                            value={volume} 
                            track="inverted" 
                            onChange={(e, newValue) => { dispatch(setVolume(newValue)); dispatch(setPreviousVolume(newValue)); }} 
                            aria-label="Volume" 
                            sx={{ 
                            width: 100, 
                            color: '#fff', 
                            textAlign: 'center', 
                            direction: 'rtl', // Reverse the slider direction
                            opacity: volumeHover ? 1 : 0, // Fade in and out
                            visibility: volumeHover ? 'visible' : 'hidden', // Visibility toggles after opacity
                            transition: 'opacity 0.5s ease, visibility 1s ease',
                            // marginLeft: volumeHover ? '0px' : '100px', // Slide in from right to left
                            '& .MuiSlider-track': { backgroundColor: 'white' }, 
                            '& .MuiSlider-rail': { backgroundColor: 'gray' }, 
                            '& .MuiSlider-thumb': { backgroundColor: 'white' }
                            }}
                            // hide slider on mobile when bootstrap reads smaller than md
                            className={isMobile || isTablet ? 'd-none d-md-block' : ''}
                        />
                        <button className='top-player-buttons'>
                            {volume === 0 ?
                            <FontAwesomeIcon icon={faVolumeXmark} flip='horizontal' onClick={() => dispatch(setVolume(previousVolume))}/> :  
                            <FontAwesomeIcon icon={faVolumeHigh} flip='horizontal' onClick={() => dispatch(setVolume(0))}/>
                            }
                        </button>
                        </div>
                        <button 
                            className='top-player-buttons'
                            onClick={() => toggleFullscreen(containerRef, videoRef)} style={{ marginLeft: '10px' }}
                        >
                        {isFullscreen ?
                            <FontAwesomeIcon icon={faDownLeftAndUpRightToCenter} /> :
                            <FontAwesomeIcon icon={faUpRightAndDownLeftFromCenter} />
                        }
                        </button>
                        <button 
                            id='settings'
                            className='top-player-buttons' 
                            style={{ marginLeft: '15px' }} 
                            onClick={(e) => { handleSettingIconClick(e) }}
                        >
                        <FontAwesomeIcon icon={faGear} />
                        </button>
                    </div>
                </div>
            )}

            {hovering && showSettings && settingsView === 'main' && !isBuffering && (
            <PlayerSettings videoRef={videoRef} />
            )}


            {hovering && showSettings && settingsView === 'playbackSpeed' && !isBuffering && (
            <PlaybackSpeedSettings videoRef={videoRef} />
            )}

            {/* {hovering && showSettings && settingsView === 'quality' && (
            <QualitySettings videoRef={videoRef} setSettingsView={setSettingsView} />
            )} */}
        </div>
    )
}

export default TopPlayerButtons